import React, { useEffect } from 'react';
import './App.css';
import Portfolio from './components/Portfolio';
import ReactGA from 'react-ga4';

function App() {
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);

  return (
    <div className="App">
      <Portfolio />
    </div>
  );
}

export default App;